interface LoadingProps {
  color?: string;
}

const Loading: React.FC<LoadingProps> = ({ color }) => {
  return (
    <div className={`w-8 h-8 border-4 border-${color}-500 border-t-transparent rounded-full animate-spin mx-auto mb-4`}></div>
  )
}

export default Loading;